import { render, staticRenderFns } from "./BSwitch.vue?vue&type=template&id=49112609"
import script from "./BSwitch.vue?vue&type=script&lang=js"
export * from "./BSwitch.vue?vue&type=script&lang=js"
import style0 from "./BSwitch.vue?vue&type=style&index=0&id=49112609&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports